module.exports = __webpack_public_path__ + "img/prize-type-3.4c8e9eb3.png";